<template>
    <div class="position-relative d-inline-block">
        <b-button
            :id="`variable-button-${_uid}`"
            ref="openButton"
            class="d-inline-flex align-items-center justify-content-center openButtonIgnore"
            href="#"
            tabindex="0"
            type="button"
            variant="flat-secondary"
            @click="openVariableSelect"
        >
            <font-awesome-icon :icon="['far', 'brackets-curly']" class="cursor-pointer openButtonIgnore" size="1x" />
        </b-button>

        <b-popover
            :show.sync="showPopover"
            :target="`variable-button-${_uid}`"
            custom-class="variable-picker"
            triggers=""
        >
            <select-variable
                ref="selectVariableComponent"
                v-click-outside="{
                    exclude: ['openButtonIgnore'],
                    handler: 'closePopover',
                }"
                :exclude="exclude"
                :include="include"
                always-open
                @input="selectVariable"
            />
        </b-popover>
    </div>
</template>

<script>
import { BButton, BPopover } from "bootstrap-vue";
import { defineComponent, nextTick, ref } from "@vue/composition-api";
import SelectVariable from "@/components/selectVariable.vue";

export default defineComponent({
    components: {
        BButton,
        BPopover,
        SelectVariable,
    },
    props: {
        exclude: {
            type: Array,
            required: false,
        },
        include: {
            type: Array,
            required: false,
        },
    },
    setup(_, { emit, refs }) {
        const selectedVariable = ref("");

        const showPopover = ref(false);

        const selectVariableComponent = ref();

        const selectVariable = (variable) => {
            emit("select", variable);
            showPopover.value = false;
            refs.openButton.blur();
        };

        const openVariableSelect = () => {
            showPopover.value = true;
            nextTick(() => {
                // Sleep for 500 seconds to make sure element is displayed
                setTimeout(() => selectVariableComponent.value.focusSearch(), 500);
            });
        };

        const closePopover = () => {
            showPopover.value = false;
        };

        return {
            selectVariableComponent,
            openVariableSelect,
            selectedVariable,
            selectVariable,
            showPopover,
            closePopover,
        };
    },
});
</script>

<style lang="scss">
.variable-picker {
    .vs__dropdown-menu {
        position: relative;
        margin-top: 10px;
        box-shadow: none;
    }
}
</style>
